import { useQuery } from "@tanstack/react-query";
import axiosAPI from "../axiosAPI";

export const FINANCIAL_REPORT_TYPES = [
  {
    value: "honorarios-recebidos",
    label: "Honorários Recebidos",
    filename: "honorarios-recebidos",
  },
  {
    value: "honorarios-por-cliente",
    label: "Honorários por Cliente",
    filename: "honorarios-por-cliente",
  },
  {
    value: "receitas-por-mes",
    label: "Receitas por Mês",
    filename: "receitas-por-mes",
  },
  {
    value: "despesas-por-mes",
    label: "Despesas por Mês",
    filename: "despesas-por-mes",
  },
  {
    value: "fluxo-de-caixa",
    label: "Fluxo de Caixa",
    filename: "fluxo-de-caixa",
  },
];

export function getFinancialReportMeta(type) {
  return (
    FINANCIAL_REPORT_TYPES.find((r) => r.value === type) ||
    FINANCIAL_REPORT_TYPES[0]
  );
}

function buildReportQuery(filters = {}) {
  const params = new URLSearchParams();
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  if (!filters.from && !filters.to) {
    if (filters.year != null) params.set("year", String(filters.year));
    if (filters.month != null) params.set("month", String(filters.month));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

/**
 * Fetches a financial report by type.
 * @param {string|null} type - report slug (e.g. honorarios-recebidos)
 * @param {{ from?: string, to?: string, year?: number, month?: number }|null} filters
 * @param {{ enabled?: boolean }} options
 */
export const useFinancialReport = (type, filters = null, options = {}) => {
  const { enabled = true } = options;
  const queryString = buildReportQuery(filters || {});
  const canFetch = Boolean(enabled && type);

  const query = useQuery({
    queryKey: ["financial", "reports", type, queryString],
    queryFn: async () => {
      const { data } = await axiosAPI.get(
        `/financial/reports/${type}${queryString}`
      );
      return data;
    },
    enabled: canFetch,
  });

  return {
    data: query.data ?? null,
    items: query.data?.items ?? [],
    months: query.data?.months ?? [],
    totals: query.data?.totals ?? null,
    from: query.data?.from ?? filters?.from ?? null,
    to: query.data?.to ?? filters?.to ?? null,
    isLoading: canFetch && query.isLoading,
    isFetching: query.isFetching,
    isError: Boolean(query.error),
    error: query.error,
    refetch: query.refetch,
  };
};
